import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { hasPermission, normalizeRole } from "../utils/permissions";

export const futureModulesEnabled = process.env.REACT_APP_ENABLE_FUTURE_MODULES === "true";

export const primaryModules = [
  { key: "overview", labelKey: "platform.nav.overview", label: "Inicio", to: "/overview", icon: <DashboardOutlinedIcon /> },
  { key: "monitoring", labelKey: "platform.nav.monitoring", label: "Monitoreo", to: "/monitoring/live", icon: <CameraAltOutlinedIcon /> },
  { key: "incidents", labelKey: "platform.nav.incidents", label: "Alertas", to: "/incidents", icon: <FactCheckOutlinedIcon /> },
  { key: "analytics", labelKey: "platform.nav.analytics", label: "Informes", to: "/analytics/detections", icon: <AnalyticsOutlinedIcon /> },
  { key: "system", labelKey: "platform.nav.system", label: "Administracion", to: "/system/edge", icon: <SettingsOutlinedIcon /> },
];

export const primaryModulesForRole = (role) => primaryModules.filter((module) => {
  if (module.key === "monitoring") return hasPermission(role, "cameras:view");
  if (module.key === "incidents") return hasPermission(role, "alerts:view");
  if (module.key === "analytics") return hasPermission(role, "reports:view");
  if (module.key === "system") return normalizeRole(role) !== "vigilante" && (hasPermission(role, "health:view") || hasPermission(role, "users:manage"));
  return true;
});

export const monitoringTabs = [
  { labelKey: "platform.tabs.live", label: "En vivo", to: "/monitoring/live" },
  { label: "Grabaciones", to: "/monitoring/recordings" },
  ...(futureModulesEnabled ? [{ labelKey: "platform.tabs.map", label: "Mapa", to: "/monitoring/map" }] : []),
];

export const incidentTabs = [
  { labelKey: "platform.tabs.alerts", label: "Alertas", to: "/incidents" },
];

export const intelligenceTabs = [
  { labelKey: "platform.tabs.storeMap", label: "Store Map", to: "/intelligence/map" },
  { labelKey: "platform.tabs.heatmaps", label: "Heatmaps", to: "/intelligence/heatmaps" },
  { labelKey: "platform.tabs.forensicSearch", label: "Forensic Search", to: "/intelligence/forensic-search" },
  { labelKey: "platform.tabs.journeys", label: "Journeys", to: "/intelligence/person-journey" },
];

export const analyticsTabs = [
  { labelKey: "analyticsCross.title", label: "Detecciones", to: "/analytics/detections" },
  { labelKey: "platform.tabs.lossPrevention", label: "Hurtos", to: "/analytics/loss-prevention" },
  { labelKey: "platform.tabs.reports", label: "Reportes", to: "/analytics/reports" },
  ...(futureModulesEnabled ? [
    { labelKey: "platform.tabs.stores", label: "Tiendas", to: "/analytics/stores" },
    { labelKey: "platform.tabs.ai", label: "IA", to: "/analytics/ai" },
  ] : []),
];

export const systemTabs = [
  { label: "Edge / Dispositivos", to: "/system/edge", permission: "users:manage" },
  { labelKey: "platform.tabs.users", label: "Usuarios", to: "/system/users", permission: "users:manage" },
  { labelKey: "platform.tabs.notifications", label: "Notificaciones", to: "/system/notifications", permission: "users:manage" },
  { labelKey: "platform.tabs.health", label: "Diagnostico", to: "/system/health", permission: "health:view" },
  { labelKey: "platform.tabs.audit", label: "Auditoria", to: "/system/audit", permission: "audit:view" },
  { labelKey: "platform.tabs.advanced", label: "Herramientas", to: "/system/advanced", permission: "users:manage" },
];

export const systemTabsForRole = (role) => systemTabs.filter((tab) => hasPermission(role, tab.permission));
